export const formataNome = (nome, maxLength) => {
    if (nome.length > maxLength) {
        return nome.slice(0, maxLength) + '...';
    }
    return nome;
};